"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = (0, tslib_1.__importStar)(require("react"));
var NavBar_1 = (0, tslib_1.__importDefault)(require("../NavBar"));
var GlobalSettingsPanel_1 = (0, tslib_1.__importDefault)(require("../GlobalSettingsPanel"));
function Header() {
    var _a = (0, react_1.useState)(false), globalSettingsPanelOpen = _a[0], setGlobalSettingsPanelOpen = _a[1];
    var toggleGlobalSettingsPanel = function () {
        return setGlobalSettingsPanelOpen(!globalSettingsPanelOpen);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(NavBar_1.default, { settingsOpen: globalSettingsPanelOpen, openGlobalSettingsPanel: toggleGlobalSettingsPanel }),
        react_1.default.createElement(GlobalSettingsPanel_1.default, { open: globalSettingsPanelOpen, close: toggleGlobalSettingsPanel })));
}
exports.default = Header;
